import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";
import {formatQueryParams} from "../../util/queryParams";

export const createTransactionService = async data => {
  return privateRequest.post(ConfEnv.API_WALLET.URL_TRANSFER, data);
};

export const getTransactionsHistory = async filter => {
  const params = formatQueryParams([filter]);
  return privateRequest.get(`${ConfEnv.API_WALLET.URL_TRANSACTION_HISTORY}${params}`);
};

/**
 * Fetch gaming transactions with cursor pagination
 * @param {Object} filters - Query parameters
 * @param {string} filters.cursor - Pagination cursor (empty for first page)
 * @param {number} filters.limit - Items per page (default: 20, max: 50)
 * @param {string} filters.provider - Filter by provider (optional)
 * @param {string} filters.game_category - Filter by game category (optional)
 * @param {string} filters.start_date - Start date in RFC3339 format (optional)
 * @param {string} filters.end_date - End date in RFC3339 format (optional)
 * @param {boolean} filters.include_summary - Include summary statistics (optional)
 * @returns {Promise} Gaming transactions response
 */
export const getGamingTransactions = async (filters = {}) => {
  const params = formatQueryParams([filters]);
  return privateRequest.get(`${ConfEnv.API_WALLET.URL_GAMING_TRANSACTIONS}${params}`);
};
